<app-header [forceLightBackground]="true"></app-header>
<div class="conversation-page">
  <div class="conversation-page--layout">
    @switch (panel) {
      @case ('consumer') {
        <app-consumer-sidebar
          class="conversation-page--sidebar"
        ></app-consumer-sidebar>
      }
      @case ('provider') {
        <app-provider-sidebar
          class="conversation-page--sidebar"
        ></app-provider-sidebar>
      }
      @case ('org-admin') {
        <app-org-admin-sidebar
          class="conversation-page--sidebar"
        ></app-org-admin-sidebar>
      }
    }
    <div class="conversation-page--content">
      @if (context) {
        <section class="conversation">
          <header class="conversation__header">
            <div class="conversation__heading">
              <button
                type="button"
                class="conversation__back"
                aria-label="Back to requests"
                (click)="goBack()"
              >
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M19 12H5M5 12L12 19M5 12L12 5"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <h1 class="conversation__title">Conversation</h1>
              <p class="conversation__subtitle">{{ subtitle }}</p>
            </div>
            <hr class="conversation__divider" />
          </header>

          <div class="conversation__asset">
            <div>
              <p class="conversation__asset-name">{{ context.assetName }}</p>
              <p class="conversation__asset-purpose">
                <strong>Purpose :</strong>
                @if (context.purpose) {
                  {{ context.purpose }}
                } @else if (!purposeLoading) {
                  N/A
                }
              </p>
            </div>
            <span
              class="conversation__status"
              [class.conversation__status--approved]="
                context.status === 'granted' ||
                context.status === 'approved' ||
                context.status === 'active'
              "
              [class.conversation__status--rejected]="
                context.status === 'rejected' || context.status === 'revoked'
              "
              [class.conversation__status--withdrawn]="
                context.status === 'withdrawn' || context.status === 'expired'
              "
            >
              {{ statusLabel }}
            </span>
          </div>

          <div class="conversation__panel">
            <div class="conversation__messages" #messageList>
              @if (!loading && !messages.length) {
                <p class="conversation__empty">Conversation not found</p>
              }
              <div class="conversation__thread">
                @for (group of dayGroups; track group.label) {
                  <div class="conversation__day" role="separator">
                    <span class="conversation__day-label">{{
                      group.label
                    }}</span>
                  </div>
                  @for (message of group.messages; track message.id) {
                    <div
                      class="conversation__message"
                      [class.conversation__message--mine]="
                        message.author === 'me'
                      "
                      [class.conversation__message--editing]="
                        message.id === editingMessageId
                      "
                    >
                      <div class="conversation__bubble">
                        <div class="conversation__meta">
                          <span class="conversation__author">{{
                            authorLabel(message)
                          }}</span>
                          <span class="conversation__dot">.</span>
                          <span class="conversation__time">{{
                            relativeTime(message.createdAt)
                          }}</span>
                          @if (message.internal) {
                            <span class="conversation__internal"
                              >Internal Note</span
                            >
                          }
                          @if (canModify(message)) {
                            <span class="conversation__message-actions">
                              <button
                                type="button"
                                class="conversation__icon-btn"
                                aria-label="Edit message"
                                (click)="startEdit(message)"
                              >
                                <img
                                  src="/assets/edit-icon.svg"
                                  alt=""
                                  width="13"
                                  height="13"
                                />
                              </button>
                              <button
                                type="button"
                                class="conversation__icon-btn"
                                aria-label="Delete message"
                                (click)="requestDelete(message)"
                              >
                                <img
                                  src="/assets/delete.svg"
                                  alt=""
                                  width="16"
                                  height="16"
                                />
                              </button>
                            </span>
                          }
                        </div>
                        <p class="conversation__text">{{ message.text }}</p>
                      </div>
                    </div>
                  }
                }
              </div>
            </div>

            @if (!isReadOnly) {
            <div class="conversation__composer">
              @if (canAddInternalNote) {
                <label class="conversation__note-toggle">
                  <input
                    type="checkbox"
                    [(ngModel)]="isInternalNote"
                    [disabled]="!!editingMessageId"
                  />
                  <span>Make it as internal note</span>
                </label>
              }
              <div
                class="conversation__input-row"
                [class.conversation__input-row--editing]="!!editingMessageId"
              >
                <div class="conversation__input-wrap">
                  <textarea
                    #composerInput
                    rows="1"
                    class="conversation__input"
                    [class.conversation__input--error]="!!errorMessage"
                    [class.conversation__input--editing]="!!editingMessageId"
                    placeholder="Write your message..."
                    aria-label="Write your message"
                    [attr.aria-invalid]="!!errorMessage"
                    aria-describedby="conversation-error"
                    [maxlength]="messageMaxLength"
                    [(ngModel)]="draft"
                    (input)="onDraftInput($event)"
                    (keydown)="onComposerKeydown($event)"
                  ></textarea>
                  @if (editingMessageId) {
                    <button
                      type="button"
                      class="conversation__cancel-edit"
                      (click)="cancelEdit()"
                    >
                      Cancel
                    </button>
                  }
                </div>
                <button
                  type="button"
                  class="conversation__send"
                  aria-label="Send message"
                  (click)="send()"
                >
                  <img
                    src="/assets/send-icon.svg"
                    alt=""
                    width="18"
                    height="20"
                  />
                </button>
              </div>
              @if (errorMessage) {
                <p
                  id="conversation-error"
                  class="conversation__error"
                  [class.conversation__error--editing]="!!editingMessageId"
                  role="alert"
                >
                  {{ errorMessage }}
                </p>
              } @else if (replyLimitReached) {
                <p
                  id="conversation-error"
                  class="conversation__notice"
                  role="status"
                >
                  {{ replyLimitMessage }}
                </p>
              }
            </div>
            }
          </div>
        </section>
        @if (editingMessageId) {
          <div class="conversation__edit-backdrop" aria-hidden="true"></div>
        }
        <app-confirmation-dialog
          [visible]="!!messagePendingDelete"
          type="delete"
          themeColor="red"
          width="380px"
          title="Delete Message?"
          message="Are you sure you want to delete message?"
          confirmLabel="Delete"
          cancelLabel="Cancel"
          (onConfirm)="confirmDelete()"
          (onClose)="cancelDelete()"
        ></app-confirmation-dialog>
      }
    </div>
  </div>
</div>
